import AppForm from '../app-components/Form/AppForm';

Vue.component('employee-attendance-form', {
    mixins: [AppForm],
    props: {
        trans: { type: Object },
        quarters: { type: Array }
    },
    
    data: function() {
        return {
            mutableQuarters: this.quarters,
            activeQuarter: this.quarters[0]
        };
    },

    methods: {
        correctBasicInputDecimals(vmodelName,$event)
        {
            this.activeQuarter[vmodelName] = this.sanitizeDecimalPoint($event.target.value ? $event.target.value : 0);
        },
        
        sanitizeDecimalPoint(val)
        {
            val = ""+val;
            return (val ? val.replace(",",".") : val);
        },
        
        selectQuarter: function(item)
        {
            this.activeQuarter = item;
        },
        
        getData: function()
        {
            return this.mutableQuarters;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeAttendanceForm.js